import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css']
})
export class GroupsComponent implements OnInit {
  menuState: string = 'out';
  countryFilter: String = '';
  cityFilter: String = '';
  userFilter: Number = 0;
  grid: Boolean = false;
  groups: Array<any> = [];
  allGroups: Array<any> = []
  myGroup = this.apiservice.user.group;
  url = this.apiservice.url + '/uploads/';
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.apiservice.getAllGroups().subscribe((res: any) => {
      this.allGroups = res.data;
      this.groups = res.data;
    });
  }

  joinedOrNot(subscribers) {
    if (subscribers) {
      let index = subscribers.findIndex(data => data._id == this.apiservice.user._id);
      if (index >= 0) {
        return true;
      }
      return false;
    }
  }

  join(group_id) {
    let users = [];
    users.push(this.apiservice.user._id);
    this.myGroup.push(group_id);
    this.apiservice.assignGroup({ group: this.myGroup, users: users }).subscribe((res: any) => {
      this.getData();
    });
  }

  unjoin(group_id) {
    let users = [];
    users.push(this.apiservice.user._id);
    let index = this.myGroup.findIndex(data => data == group_id);
    this.myGroup.splice(index, 1);
    this.apiservice.deAssignGroup({ group: this.myGroup, users: users }).subscribe((res: any) => {
      this.getData();
    });
  }

  open(group) {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }

  appylyFilters() {
    let mainData = this.allGroups;
    if (this.userFilter > 0) {
      mainData = mainData.filter(data => data.subscribers.length <= this.userFilter);
    }

    if (this.countryFilter) {
      mainData = mainData.filter(data => data.country.toLowerCase().includes(this.countryFilter.toLowerCase()));
    }
    if (this.cityFilter) {
      mainData = mainData.filter(data => data.city.toLowerCase().includes(this.cityFilter.toLowerCase()));
    }
    this.groups = mainData;
  }

}
